"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Modal = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, style = _a.style, children = _a.children, onOverlayClick = _a.onOverlayClick;
    if (isHidden) {
        document.body.style.overflow = 'visible';
        return null;
    }
    else {
        document.body.style.overflow = 'hidden';
    }
    var handleOverlayClick = function (_a) {
        var currentTarget = _a.currentTarget, target = _a.target;
        if (!onOverlayClick || currentTarget !== target)
            return;
        onOverlayClick();
    };
    return (react_1.default.createElement(styles_1.default, { className: className || '', onClick: handleOverlayClick },
        react_1.default.createElement("section", { className: "frame", style: style }, children)));
};
exports.default = Modal;
//# sourceMappingURL=index.js.map